import React, { forwardRef, useEffect, useState } from 'react';
import type { MenuProps } from '@mui/material';
import { Menu as MenuMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

type Props = {
  anchorEl?: (EventTarget & HTMLButtonElement) | null;
};

const Menu = forwardRef<HTMLDivElement, MenuProps & Props>(({ open, ...props }, ref) => {
  const [listWidth, setListWidth] = useState(0);

  useEffect(() => {
    setListWidth(props.anchorEl?.clientWidth || 0);
  });

  return (
    <MenuMUI
      open={open}
      {...omitUndefinedProps(props)}
      ref={ref}
      style={{
        ...(props.style || {}),
        minWidth: listWidth,
      }}
    />
  );
});

Menu.displayName = 'Menu';

export default Menu;
